<script setup lang="ts">
import { ref } from "vue";
import FilterMenuDesktop from "@/components/ads/FilterMenuDesktop.vue";
import AppModal from "@/components/ui/AppModal.vue";

defineProps([
  "form",
  "states",
  "statesLoading",
  "cities",
  "citiesLoading",
  "sources",
  "brands",
  "brandsLoading",
  "models",
  "modelsLoading",
  "yearRanges",
  "years",
  "priceRanges",
  "fipePercentRanges",
  "fipePercentRangesLoading",
  "fipeRanges",
  "fipeRangesLoading",
]);
const searchBarMobileVisible = ref(false);
const showFilterModal = ref(false);
</script>

<template>
  <div class="search-bar d-block d-md-none">
    <div class="container">
      <div class="search-bar-row">
        <div v-show="!searchBarMobileVisible" class="search-bar-btn-filter">
          <button @click="showFilterModal = true">
            Filtros avançados
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="currentColor"
              class="bi bi-chevron-down"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </button>
        </div>
        <div
          v-if="false"
          class="search-bar-item"
          :class="{ 'search-bar-item-expanded': searchBarMobileVisible }"
        >
          <div>
            <div v-if="searchBarMobileVisible" class="input-group">
              <input
                type="text"
                class="form-control"
                id="input-search"
                placeholder="Pesquise aqui..."
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  id="button-close-search"
                  @click="searchBarMobileVisible = !searchBarMobileVisible"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="currentColor"
                    class="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <button
              v-else
              class="btn btn-outline-secondary"
              type="button"
              id="button-search"
              @click="searchBarMobileVisible = !searchBarMobileVisible"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-search"
                viewBox="0 0 16 16"
              >
                <path
                  d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AppModal v-if="showFilterModal" @close="showFilterModal = false">
    <template v-slot:header> Filtros avançados </template>
    <template v-slot:body>
      <FilterMenuDesktop
        :form="form"
        :states="states"
        :statesLoading="statesLoading"
        :sources="sources"
        :cities="cities"
        :citiesLoading="citiesLoading"
        :brands="brands"
        :brandsLoading="brandsLoading"
        :models="models"
        :modelsLoading="modelsLoading"
        :yearRanges="yearRanges"
        :years="years"
        :priceRanges="priceRanges"
        :fipePercentRanges="fipePercentRanges"
        :fipePercentRangesLoading="fipePercentRangesLoading"
        :fipeRanges="fipeRanges"
        :fipeRangesLoading="fipeRangesLoading"
      />
    </template>
  </AppModal>
</template>

<style scoped>
#button-search {
  padding: 0 8px;
}

#input-search {
  padding: 0 15px;
}

#button-close-search {
  padding: 0 5px;
  border-radius: 0 16px 16px 0;
}

.search-bar {
  background-color: var(--primary-color);
  padding: 6px 0 6px;
}

.search-bar-row {
  display: flex;
  justify-content: flex-end;
}

.search-bar-item {
  display: block;
  margin-left: 10px;
  width: 32px;
  /* transition: width .5s; */
}

.search-bar-item-expanded {
  width: 100%;
  margin-left: 0;
  width: 100%;
}

.search-bar .btn-outline-secondary {
  border-radius: 50%;
  background: var(--white-ice);
  color: var(--black-eigengrau);
  border-width: 0;
  height: 32px;
  display: inline-block;
}

.search-bar .btn-outline-secondary:hover {
  color: var(--primary-color);
  box-shadow: none;
}

.search-bar .btn-outline-secondary:focus {
  box-shadow: none;
}

.search-bar-btn-filter {
  width: 100%;
  position: relative;
  color: var(--black-eigengrau);
}

.search-bar-btn-filter button {
  width: 100%;
  text-align: left;
  padding: 4px 30px 5px 10px;
  border-radius: 0.5rem;
  border: 1px solid var(--white-ice);
  background-color: var(--white-ice);
  color: var(--black-eigengrau);
  font-weight: 500;
}

.search-bar-btn-filter svg {
  position: absolute;
  top: 7px;
  right: 6px;
}

.search-bar .input-group {
  width: 100%;
  flex-wrap: nowrap;
  display: flex;
  vertical-align: middle;
}

.search-bar .form-control {
  border-radius: 16px;
  background: var(--white-ice);
  border-width: 0;
  width: 100%;
  border: 0;
  height: 32px;
}

.search-bar .form-control:focus {
  box-shadow: none;
  border: 0;
}
</style>
